import { UiNavLinkModel } from "../../models";

export function mockUiNavLinkModel({
    id = "ui-nav-link-1234",
    type = "uiNavLink",
    locale = "en",
    content = mockUiNavLinkModelContent()
}: Partial<UiNavLinkModel> = {}): UiNavLinkModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiNavLinkModelContent = UiNavLinkModel["content"];

export function mockUiNavLinkModelContent({
    entryTitle = "Trello Nav Link",
    titleHeading = "Lorem Ipsum",
    description = "Lorem ipsum sit dolor amet adepiscing consecutor qui",
    url = "/lorem-ipsum",
    ...optionals
}: Partial<UiNavLinkModelContent> = {}): UiNavLinkModelContent {
    return {
        entryTitle,
        titleHeading,
        description,
        url,
        ...optionals
    };
}
